import { Button, ButtonGroup, ConfirmModal, useDisclosure, useToast } from '@eigtech/ui-shared-dave'
import { useDeleteDocument } from '@eigtech/ui-shared-documents'
import { DocumentColumn, UpdateDocumentDrawer } from '@eigtech/ui-shared-documents-web'
import { useState } from 'react'

export function DocumentMobileActions({ document }: { document: DocumentColumn }) {
  const [isOpenUpdateDocumentDrawer, setIsOpenUpdateDocumentDrawer] = useState(false)

  const toast = useToast()
  const confirmModal = useDisclosure()

  const { mutateAsync: deleteDocument, isPending } = useDeleteDocument()

  async function confirmDeleteDocument() {
    await deleteDocument({ entityId: document.entityId, documentId: document.id })

    toast({
      status: 'success',
      title: 'Successfully deleted document',
    })
  }

  if (document.source !== 'Estimator') {
    return null
  }

  return (
    <>
      <ButtonGroup isAttached variant="outline">
        <Button onClick={() => setIsOpenUpdateDocumentDrawer(true)}>Update Document</Button>
        <Button colorScheme="red" onClick={confirmDeleteDocument}>
          Delete Document
        </Button>
      </ButtonGroup>

      {confirmModal.isOpen && (
        <ConfirmModal
          {...confirmModal}
          confirmLabel="Delete"
          confirmProps={{ colorScheme: 'red' }}
          isPending={isPending}
          title="Delete Document"
          onConfirm={confirmDeleteDocument}
        >
          Are you sure you want to delete this document?
        </ConfirmModal>
      )}

      {isOpenUpdateDocumentDrawer && (
        <UpdateDocumentDrawer
          document={document}
          open={isOpenUpdateDocumentDrawer}
          onOpenChange={setIsOpenUpdateDocumentDrawer}
        />
      )}
    </>
  )
}
